export const BASE_URL = 'https://server.rps.co.zw';
